import siteJson from '../../content/data/site.json';
import socialJson from '../../content/data/social.json';
import iconsJson from '../../content/data/icons.json';
import videosJson from '../../content/data/videos.json';
import statsJson from '../../content/data/stats.json';

import type {
  SiteData, VideosData, StatsData, SocialLink, ResolvedSocialLink,
} from './types';

export const site = siteJson as SiteData;
export const videos = videosJson as VideosData;
export const stats = statsJson as StatsData;

const icons = iconsJson as Record<string, string>;

export const logoSvg = icons.logo;

export function resolveSocialLinks(links: SocialLink[]): ResolvedSocialLink[] {
  return links.map((link) => {
    const iconSvg = icons[link.icon];
    if (!iconSvg) throw new Error(`Unknown icon key: ${link.icon}`);
    return { title: link.title, url: link.url, iconSvg };
  });
}

export const socialLinks: SocialLink[] = (socialJson as { links: SocialLink[] }).links;
